import { Component, OnInit, ElementRef, ViewChild  } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators,FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from '@app/_services';
import { first } from 'rxjs/operators';
declare var $:any;
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '@app/_services';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  login_form: UntypedFormGroup;
  pwdreset_form: UntypedFormGroup;
  pwdforgot_form: UntypedFormGroup;
  submitted = false;
  submit_f_password = false;

  isLoading = false;
  nSubModule = 1;

  closeResult :string
  constructor(
      private router: Router,
      private modalService: NgbModal,
      private accountService: AccountService, 
      private dataService: DataService,
      private toastr: ToastrService,fb: UntypedFormBuilder) {  
        this.login_form = fb.group({
        // 'email': [null, Validators.compose([Validators.required, Validators.pattern(/^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)])],
        'email': [null, Validators.required],
        'password': [null, Validators.required],
        'remember': [false]
      }); 

      this.pwdreset_form= fb.group({
        // 'email': [null, Validators.compose([Validators.required, Validators.pattern(/^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)])],
        'password': [null, Validators.required],
        'c_password': [null, Validators.required],
      });

      this.pwdforgot_form= fb.group({
        'email': [null, Validators.compose([Validators.required, Validators.pattern(/^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)])]
      });
    
    }

      
      ngOnInit(): void {
        this.checkIsRemember();
      }
      forgotPassword(){
        this.nSubModule = 3;
      }
      clickforgotpassword(){
        if(this.f2.email.value==null||this.f2.email.value==""){
          this.toastr.warning("Enter Email", "Warning");
          return;
        }
        if (this.pwdforgot_form.valid) {
          this.isLoading = true;
          this.accountService.forgotpassword(this.f2.email.value)
            .pipe(first())
            .subscribe(
            (response) => {
              console.log(response);
              this.isLoading = false;
              if(response.state == "ERROR") {
                  this.toastr.warning(response.message, "Warning", {timeOut: 1000});
              } else if(response.state == "SUCCESS") {
                this.toastr.success("Password send to your email successfully", "Please login to continue", {timeOut: 1000});
                this.login_form.controls.password.setValue("");
                this.pwdforgot_form.controls.email.setValue("");
                this.nSubModule = 1;
              }
            },
            (error) => { 
              console.log('error caught in component', error)
              this.isLoading = false;
            }
          );
        }else{
          this.toastr.warning("Invalid entry", "Warning", {timeOut: 1000});
        }

        
      }

      updatepassword(){
        var formValues = this.pwdreset_form.getRawValue;


        if(this.f1.password.value==null||this.f1.password.value==""){
          this.toastr.warning("Enter New Password", "Warning", {timeOut: 1000});
          return;
        }
        if(this.f1.c_password.value==null||this.f1.c_password.value==""){
          this.toastr.warning("Enter Confirm Password", "Warning", {timeOut: 1000});
          return;
        }
        if(this.f1.password.value.length<6||this.f1.c_password.value.length<6){
          this.toastr.warning("Password should be at least 6 characters", "Warning", {timeOut: 1000});
          return;
        }
        if(this.f1.password.value ==="grt123"){
          this.toastr.warning("Please change the New password. It should not be a default password", "Warning", {timeOut: 1000});
          return;
        }
        if(this.f1.password.value !==this.f1.c_password.value ){
          this.toastr.warning("New Password and Confirm Password does not match. Please check again", "Warning", {timeOut: 1000});
          return;
        }

        if (this.pwdreset_form.valid) {
  
          this.isLoading = true;
          this.accountService.updatepassword(this.f.email.value, this.f1.password.value)
            .pipe(first())
            .subscribe(
            (response) => {
              console.log(response)
              this.isLoading = false;
              if(response.state == "ERROR") {
                  this.toastr.warning(response.message, "Warning", {timeOut: 1000});
              } else if(response.state == "SUCCESS") {
                this.toastr.success("Password updated successfully", "Please login to continue", {timeOut: 1000});
                this.login_form.controls.password.setValue("");
                this.pwdreset_form.controls.password.setValue("");
                this.pwdreset_form.controls.c_password.setValue("");
                this.nSubModule = 1;
              }
            },
            (error) => { 
              console.log('error caught in component', error)
              this.isLoading = false;
            }
          );
        }else{
          this.toastr.warning("Invalid entry", "Warning", {timeOut: 1000});
        }

      }

      back_to_Login(){
        this.nSubModule = 1;
      }
      checkIsRemember() {
        var userdata = localStorage.getItem('userInformation');
        var parsedUserData = JSON.parse(userdata);
        console.log(parsedUserData)
        if(parsedUserData!==null){
          if(parsedUserData.remember){
            this.login_form.controls.email.setValue(parsedUserData.email);
            this.login_form.controls.password.setValue(parsedUserData.password);
            this.login_form.controls.remember.setValue(true);
          }else{
            this.login_form.controls.email.setValue("");
            this.login_form.controls.password.setValue("");
            this.login_form.controls.remember.setValue(false);
          }
        }

      }

      get f() { return this.login_form.controls; }
      get f1() { return this.pwdreset_form.controls; }
      get f2() { return this.pwdforgot_form.controls; }


      
      submitForm() {
        this.submitted = true;
        if(this.f.email.value==null||this.f.email.value==""){
          this.toastr.warning("Enter Email", "Warning", {timeOut: 1000});
          return;
        }
        if(this.f.password.value==null||this.f.password.value==""){
          this.toastr.warning("Enter Password", "Warning", {timeOut: 1000});
          return;
        }
        // this.markFormTouched(this.login_form);
        if (this.login_form.valid) {
          var formValues = this.login_form.getRawValue;

          this.isLoading = true;
          this.accountService.userLogin(this.f.email.value, this.f.password.value)
            .pipe(first())
            .subscribe(
            (response) => {
              this.isLoading = false;
              if(response.state == "ERROR") {
                  this.toastr.warning(response.message, "Warning");
              } else if(response.state == "SUCCESS") {
                
                localStorage.removeItem('authtoken');
                localStorage.removeItem('userInformation');
                localStorage.removeItem('lists');
                localStorage.clear();
                
                var userInformation = response.data;
                userInformation["remember"] = this.f.remember.value;
                userInformation["id"] = response.data.id;
                userInformation["email"] = response.data.email;
                userInformation["first_name"] = response.data.first_name;
                userInformation["password"] = this.f.password.value;
                userInformation["role_id"] = response.data.role_id;
                userInformation["mobile"] = response.data.mobile;
                userInformation["is_view"] = response.data.is_view;
                userInformation["role_name"] = response.data.role_name;
                userInformation["last_name"] = response.data.last_name;


                userInformation["region_id"] = response.data.region_id;
                userInformation["region_name"] = response.data.region_name;
                userInformation["showroom_name"] = response.data.showroom_name;
                userInformation["showroom_id"] = response.data.showroom_id;

                userInformation["profile_picture"] = response.data.profile_picture;
                localStorage.setItem('authtoken', response.data.token);
                localStorage.setItem('userInformation', JSON.stringify(userInformation));
                localStorage.setItem("userId", (response.data.id).toString());

  
                // @Output() fireIsLoggedIn: EventEmitter<any> = new EventEmitter<any>(); 

                this.dataService.callUserInfo();
                if(this.f.password.value ==="grt123"){
                  this.nSubModule = 2;
                  return;
                }
                this.toastr.success("Logged in successfully", "Welcome ! "+response.data.first_name +" "+response.data.last_name, {timeOut: 1000});
                this.router.navigate(['/dashboard'])
                
              }
            },
            (error) => { 
              console.log('error caught in component', error)
              this.isLoading = false;
            }
          );
        }else{
          this.toastr.warning("Invalid entry", "Warning", {timeOut: 1000});
        }
      };



      openModal(content) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'md'}).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          this.nSubModule = 1;
        });
      }
      
      private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
        } else {
          return  `with: ${reason}`;
        }
      }
}
